import { default as React, FunctionComponent, ReactElement, ReactNode } from 'react'

import { Box, Heading, mdBumps, Typo } from '../atoms'

export interface ModalHeaderProps {
  className?: string
  id?: string
  header: ReactNode
  subheader?: ReactNode
  upperContent?: ReactElement
  lowerContent?: ReactElement | string
  centered?: boolean
}

export const ModalHeader: FunctionComponent<ModalHeaderProps> = (props) => {
  const { className, header, id, subheader, lowerContent, upperContent } = props

  return (
    <Box pb={mdBumps} className={className}>
      {upperContent && <div className='upper-content'>{upperContent}</div>}

      <Heading aria-describedby='modal_subheader' typoSize='xl' as='h1' id={id}>
        {header}
      </Heading>

      {subheader && (
        <Typo className='sub-header' id='modal_subheader' pt={[4, 4, 3]}>
          {subheader}
        </Typo>
      )}
      {lowerContent && (
        <Typo typoSize='sm' className='lower-content' mt={4} p={0}>
          {lowerContent}
        </Typo>
      )}
    </Box>
  )
}
